import React, { useState } from 'react'
import DataTable from '../datatable'
import { PAGINATION_DEFAULT } from '../../utils/constants'
import { useGetAllAnnouncements } from '../../redux/employee/hook/announcement'

const AllAnnouncements = () => {
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })

  const { data: announcements } = useGetAllAnnouncements(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Announcement Title', 'Audience', 'Scheduled Published Date'],
    keys: ['title', 'recipient_type', 'publish_date'],
    mobileHeader: {
      left: {
        title: 'Announcement Title',
        key: 'title',
      },
      right: {
        title: 'Audience',
        key: 'audience',
      },
    },
  }


  return (
    <div>
      <DataTable
        data={announcements}
        tableConfig={tableConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={'announcements'}
        searchData={true}
      />
    </div>
  )
}

export default AllAnnouncements
